import { createFileRoute } from "@tanstack/react-router";
import VariantA from "@/components/funnel/variants/VariantA";
import { BRAND_META_DESCRIPTION, BRAND_NAME } from "@/components/inflow/brand";

export const Route = createFileRoute("/lp-a")({
  head: () => ({
    meta: [
      { title: `${BRAND_NAME} — Variant A` },
      { name: "description", content: BRAND_META_DESCRIPTION },
      { name: "robots", content: "noindex,nofollow" },
      { property: "og:title", content: `${BRAND_NAME} — Variant A` },
      { property: "og:description", content: BRAND_META_DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: VariantA,
});
